import { db, storage } from "../firebase-app";
import { Module } from "vuex";
import {
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
} from "firebase/firestore";
import store from ".";
import { getStorage, listAll, deleteObject, ref as storageRef, uploadString } from "firebase/storage";

const modPublish: Module<any, any> = {
  namespaced: true,
  state: {
    showPublishLoading: false,
    jsCodeInStorage: null,
    cssCodeInStorage: null,
    htmlCodeInStorage: null,

  },
  mutations: {
    setPublishLoading(state, value) {
      state.showPublishLoading = value;
    },
    setJsCodeInStorage(state, value) {
      state.jsCodeInStorage = value;
    },
    setCssCodeInStorage(state, value) {
      state.cssCodeInStorage = value;
    },
    setHtmlCodeInStorage(state, value) {
      state.htmlCodeInStorage = value;
    },


  },
  getters: {
    
  },
  actions: {
    // check if the code is synced with the storage
    





    async publishToDev({state, commit, dispatch, rootState}) {
      commit('setPublishLoading', true)

      // check if code in project matches code in storage
      const jsCodeInProject = rootState.modProjects.selectedProject.jsCode;
      const cssCodeInProject = rootState.modProjects.selectedProject.cssCode;
      const htmlCodeInProject = rootState.modProjects.selectedProject.htmlCode;
      if (state.jsCodeInStorage !== jsCodeInProject) {
        await dispatch('uploadCode', {env: 'dev', fileName: 'script.js'})
        commit('setJsCodeInStorage', jsCodeInProject)
      }
      if (state.cssCodeInStorage !== cssCodeInProject) {
        await dispatch('uploadCode', {env: 'dev', fileName: 'style.css'})
        commit('setCssCodeInStorage', cssCodeInProject)
      }
      if (state.htmlCodeInStorage !== htmlCodeInProject) {
        await dispatch('uploadCode', {env: 'dev', fileName: 'index.html'})
        commit('setHtmlCodeInStorage', htmlCodeInProject)
      }
      dispatch('checkSync')
      commit('setPublishLoading', false)
      
    },


    async uploadCode({state, commit, rootState},{env, fileName}) {
      console.log(`Uploading ${fileName} to ${env}...`)
      commit('setPublishLoading', true)
      let cdnScripts = ""
      rootState.modProjects.selectedProject.cdnList.forEach((cdn: string) => {
        cdnScripts += `<script src="${cdn}"><\/script>`
      });
      const codeStorageRef = storageRef(
        storage,
        `scripts/${rootState.modLogin.user.uid}/${rootState.modProjects.selectedProject.slug}/${env}/${fileName}`
      );
      let code = "";
      switch (fileName) {
        case 'index.html':
          code = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>${rootState.modProjects.selectedProject.id}<\/title>
    <style>${rootState.modProjects.selectedProject.cssCode}<\/style>
  <\/head>
  <body>
    ${rootState.modProjects.selectedProject.htmlCode}
    ${cdnScripts}
    <script type="text/javascript">${rootState.modProjects.selectedProject.jsCode}<\/script>
  <\/body>
<\/html>`
          break
        case 'style.css': code = rootState.modProjects.selectedProject.cssCode; break
        case 'script.js': code = rootState.modProjects.selectedProject.jsCode; break
      }
      const metadata = {
        contentType: 'text/html', // Set the correct content type
      };
      if (fileName !== 'style.css') {
        await uploadString(codeStorageRef, code, 'raw', metadata).then((snapshot) => {
          console.log("Uploaded a raw string!", snapshot);
        });
      } else {
        await uploadString(codeStorageRef, code, 'raw', {
          contentType: 'text/css'
        }).then((snapshot) => {
          console.log("Uploaded css file", snapshot);
        });

      }
      commit('setPublishLoading', false)
    },
  },
};
export default modPublish;
